<template>
  <div
    class="relative max-w-screen-4xl mx-auto h-screen flex flex-col lg:flex-row items-center justify-between px-6 lg:px-32"
  >
    <div class="absolute inset-0 overflow-hidden">
      <video
        v-show="currentVideo === 1"
        autoplay
        muted
        loop
        playsinline
        class="w-full h-full object-cover"
      >
        <source src="../assets/videos/Intro Website Video Opener.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>
  </div>

  <!-- Welcome to the official site of Barka -->
  <div class="bg-white">
    <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mt-10 mb-10">
      <h1 class="text-center text-lg font-extrabold mt-10">
        Welcome to the Official Site of <br />
        Barka U Mshelia
      </h1>
      <p class="text-center text-2xl mt-2">
        Step into the world of Barka U. Mshelia and find inspiration in the journey.
      </p>
      <p class="text-center text-2xl mt-3">
        Learn more about the inspiration, achievements and ventures of one of the globe's <br> leading real estate investor and business expert.
      </p>
    </div>
  </div>

  <!-- Meet Barka U. Mshelia -->
  <meetBarka />

  <!-- 7 Perfect Quote  -->
  <perfectQuotes />

  <!-- Barka U. Mshelia Brand -->
  <barkaBrand />

  <!-- Featured videos -->
  <!-- <featuredVideos /> -->

  <!-- Leadership Journey  -->
   <div class="mt-6">
     <leadershipJourney />
   </div>

  <!-- GMD Banner -->
  <div class="bg-white">
  <div class="md:px-10 max-w-screen-2xl mx-auto py-4 mt-10 mb-10">
    <img
      src="../assets/images/gmd-banner.png"
      alt="GMD Banner"
      class="w-full h-auto object-contain"
    />
  </div>
</div>

  <!-- About family section -->
  <aboutFamily />

  <!-- Discover your path -->
  <discoverPath />

  <!-- Why Coaching works -->
  <whyCoaching />
</template>

<script>
import meetBarka from "../components/meetBarka.vue";
import barkaBrand from "../components/barkaBrand.vue";
import discoverPath from "../components/discoverPath.vue";
import whyCoaching from "../components/whyCoaching.vue";
import featuredVideos from "../components/featuredVideos.vue";
import aboutFamily from "../components/aboutFamily.vue";
import perfectQuotes from "../components/perfectQuotes.vue";
import leadershipJourney from "../components/leadershipJourney.vue";

export default {
  components: {
    meetBarka,
    barkaBrand,
    discoverPath,
    whyCoaching,
    featuredVideos,
    aboutFamily,
    perfectQuotes,
    leadershipJourney
  },
  data() {
    return {
      slides: [
        { id: 1, image: require("../assets/images/gmd-hero.jpeg") },
        { id: 2, image: require("../assets/images/tribal-image.jpeg") }, // Add different images
        { id: 3, image: require("../assets/images/Gmdddddddddddd.png") }, // Add different images
      ],
      activeIndex: 0,
      texts: [
        "REALESTATE INVESTMENT COACH",
        "PUBLIC SPEAKER",
        "INSPIRING LEADER",
        "LEADING STRATEGIST IN LAND BANKING",
        "ENTREPRENEUR",
        "PITCH YOUR DREAM INVESTOR",
      ],
      displayedText: "",
      currentIndex: 0,
      isErasing: false,
      speed: 22,
      delayBetweenWords: 1000,
      slideInterval: null,
      isTransitioning: false,
      currentVideo: 1,
    };
  },
  mounted() {
    this.typingEffect();
    this.startSlideShow();
  },
  beforeUnmount() {
    clearInterval(this.slideInterval);
  },
  methods: {
    typingEffect() {
      const currentText = this.texts[this.currentIndex];
      if (!this.isErasing && this.displayedText.length < currentText.length) {
        this.displayedText = currentText.substring(
          0,
          this.displayedText.length + 1
        );
        setTimeout(this.typingEffect, this.speed);
      } else if (this.isErasing && this.displayedText.length > 0) {
        this.displayedText = currentText.substring(
          0,
          this.displayedText.length - 1
        );
        setTimeout(this.typingEffect, this.speed);
      } else if (
        !this.isErasing &&
        this.displayedText.length === currentText.length
      ) {
        setTimeout(() => {
          this.isErasing = true;
          this.typingEffect();
        }, this.delayBetweenWords);
      } else if (this.isErasing && this.displayedText.length === 0) {
        this.isErasing = false;
        this.currentIndex = (this.currentIndex + 1) % this.texts.length;
        this.typingEffect();
      }
    },
    startSlideShow() {
      this.slideInterval = setInterval(this.nextSlide, 5000); // Increased to 5 seconds for better UX
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      clearInterval(this.slideInterval);
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      setTimeout(() => {
        this.isTransitioning = false;
        this.startSlideShow();
      }, 1000); // Match transition duration
    },
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      clearInterval(this.slideInterval);
      this.activeIndex =
        (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      setTimeout(() => {
        this.isTransitioning = false;
        this.startSlideShow();
      }, 1000);
    },
    goToSlide(index) {
      if (this.isTransitioning || index === this.activeIndex) return;
      this.isTransitioning = true;
      clearInterval(this.slideInterval);
      this.activeIndex = index;
      setTimeout(() => {
        this.isTransitioning = false;
        this.startSlideShow();
      }, 1000);
    },
  },
};
</script>

<style scoped>
.cursor {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

/* Enhanced transition effects */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Glassmorphism effect for navigation */
.backdrop-blur-md {
  backdrop-filter: blur(12px);
}
</style>
